import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  id: number;
  field_order_sequence: number;
  field_faqs_header: string;
  field_malay_faqs_header: string;
  field_mandarin_faqs_header: string;
  field_faqs_question: string;
  field_malay_faqs_question: string;
  field_mandarin_faqs_question: string;
  field_faqs_answer: string;
  field_malay_faqs_answer: string;
  field_mandarin_faqs_answer: string;
  field_faq_published: boolean;
  created_at?: Date | null;
  updated_at?: Date | null;
  field_faq_created_by: string;
  field_faq_updated_by: string;
}

// edit api call
const fetchFAQDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await magpCMSApi.get(`/api/faqs/all-fields?id=${id}`);
  return response.data[0];
};

const useFAQDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["faqDocumentDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchFAQDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useFAQDocumentDetails };
